"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var validators_1 = require("../../core/validators/validators");
var interfaces_1 = require("./interfaces");
var ValidationPropTypes = {
    validator: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.arrayOf(PropTypes.func),
    ]),
    errorMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.objectOf(PropTypes.string),
    ]),
    onValidationChanged: PropTypes.func,
    validateOnInit: PropTypes.string,
};
var Validation = /** @class */ (function (_super) {
    __extends(Validation, _super);
    function Validation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            errors: [],
            errorsChildMap: null,
            isValid: null,
            initialValue: null,
            lastValue: null,
            lastAction: null,
        };
        _this.debouncedUpdateState = lodash_1.debounce(_this.updateState);
        return _this;
    }
    Validation.prototype.componentDidMount = function () {
        if (this.props.validateOnInit || this.props.errors) {
            this.updateState(this.props.validateOnInit);
        }
    };
    Validation.prototype.componentDidUpdate = function (prevProps, prevState) {
        // call updateState whenever value or errorsChildMap change
        if (this.state.lastAction !== interfaces_1.ACTION.RESET &&
            this.state.lastAction !== interfaces_1.ACTION.ON_INIT &&
            (prevState.lastValue !== this.state.lastValue ||
                prevState.errorsChildMap !== this.state.errorsChildMap)) {
            this.debouncedUpdateState(this.state.lastValue);
        }
    };
    /**
     * Return the child component.
     * The onChange and onBlur methods are wrapped to call the validate method
     * @param child A React Element
     */
    Validation.prototype.getChildWithValidation = function (child) {
        var _this = this;
        if (!React.isValidElement(child)) {
            console.error('Child is not a valid React element', child);
        }
        return React.cloneElement(child, {
            onInit: function (value) {
                _this.setState({
                    initialValue: value,
                    lastValue: value,
                    lastAction: interfaces_1.ACTION.ON_INIT,
                });
                if (child.props.onInit) {
                    child.props.onInit(value);
                }
            },
            onChange: function (event) {
                _this.setState({
                    lastValue: event.target.value,
                    lastAction: interfaces_1.ACTION.ON_CHANGE,
                });
                if (child.props.onChange) {
                    child.props.onChange(event);
                }
            },
            onBlur: function (event) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // on blur should not change the value 
                    this.debouncedUpdateState(this.state.lastValue);
                    if (child.props.onBlur) {
                        child.props.onBlur(event);
                    }
                    return [2 /*return*/];
                });
            }); },
            onValidationChanged: function (errorsChildMap) {
                _this.setState({ errorsChildMap: errorsChildMap });
            },
        });
    };
    Validation.prototype.updateState = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var errorsMap, valid, errors, validationResults;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errorsMap = {};
                        valid = true;
                        errors = [];
                        if (!this.props.validator) return [3 /*break*/, 4];
                        if (!(this.props.validator instanceof Array)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(this.props.validator.map(function (validator) { return validator(value); }))];
                    case 1:
                        validationResults = _a.sent();
                        errorsMap = validationResults.reduce(function (prev, curr) { return (__assign(__assign({}, prev), curr)); }, {});
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.props.validator(value)];
                    case 3:
                        errorsMap = _a.sent();
                        _a.label = 4;
                    case 4:
                        valid = (!errorsMap || lodash_1.isEmpty(errorsMap)) && !this.state.errorsChildMap;
                        if (this.props.onValidationChanged && valid !== this.state.isValid) {
                            this.props.onValidationChanged(valid, errorsMap);
                        }
                        // compute props errors
                        if (!valid && this.props.errorMessage) {
                            Object.entries(errorsMap).forEach(function (_a) {
                                var _b = __read(_a, 2), errorId = _b[0], errorVal = _b[1];
                                if (errorVal) {
                                    if (_this.props.errorMessage instanceof Object) {
                                        errors.push(_this.props.errorMessage[errorId]);
                                    }
                                    else {
                                        errors.push(_this.props.errorMessage);
                                    }
                                }
                            });
                        }
                        // compute child errors
                        if (!valid && this.state.errorsChildMap) {
                            Object.entries(this.state.errorsChildMap).forEach(function (_a) {
                                var _b = __read(_a, 2), errorId = _b[0], errorVal = _b[1];
                                if (errorVal) {
                                    if (_this.props.errorMessage instanceof Object &&
                                        _this.props.errorMessage[errorId]) {
                                        // get message error from props if exists in errorMessage
                                        errors.push(_this.props.errorMessage[errorId]);
                                    }
                                    else {
                                        // otherwise display the default one
                                        errors.push(errorVal);
                                    }
                                }
                            });
                        }
                        if (this.props.errors) {
                            errors = this.props.errors;
                        }
                        // don't change the value here otherwise there are risks we get into an infinite loop
                        this.setState({ isValid: valid, errors: errors });
                        return [2 /*return*/, errors];
                }
            });
        });
    };
    /**
     * Reset to default value and reset errors
     */
    Validation.prototype.reset = function () {
        this.setState({
            lastValue: this.state.initialValue,
            lastAction: interfaces_1.ACTION.RESET,
            isValid: null,
            errors: [],
            errorsChildMap: null,
        });
    };
    /**
     * Force validation to refresh, and return isValid state when triggered (used in Elements form before submission)
     */
    Validation.prototype.refreshValidation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateState(this.state.lastValue)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.state.isValid];
                }
            });
        });
    };
    Validation.prototype.render = function () {
        var _a;
        var _b;
        var _c = this.props, children = _c.children, validator = _c.validator;
        var childWithValidation;
        if (React.Children.count(children) === 0) {
            console.error('The Validation component requires one child component.');
        }
        else if (React.Children.count(children) > 1) {
            console.error("The Validation component can wrap only one component. Found: " + React.Children.count(children), children);
        }
        else {
            var child = React.Children.only(children);
            childWithValidation = this.getChildWithValidation(child);
        }
        var size = (_b = childWithValidation === null || childWithValidation === void 0 ? void 0 : childWithValidation.props) === null || _b === void 0 ? void 0 : _b['size']; // Experimental - Put itself automatically in small variant if the child is small
        var hasErrors = this.state.errors && this.state.errors.length;
        // aria-label to true if Validation contains a Required
        var ariaRequired = validator instanceof Array ? !!validator.find(function (v) { return v === validators_1.Validators.Required; }) : validator === validators_1.Validators.Required;
        return (React.createElement("span", { className: classnames_1.default('tk-validation', (_a = {
                    'tk-validation--error': hasErrors
                },
                _a["tk-validation--" + size] = size,
                _a)), "aria-required": ariaRequired },
            childWithValidation,
            hasErrors ? (React.createElement("ul", { className: "tk-validation__errors" }, this.state.errors.map(function (error, index) { return (React.createElement("li", { key: index, "aria-errormessage": error }, error)); }))) : null));
    };
    Validation.propTypes = ValidationPropTypes;
    return Validation;
}(React.Component));
exports.default = Validation;
